import { useEffect, useState } from "react";

function Footer() {
    const [visible, setVisible] = useState(true);

    const topFunction = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    useEffect(() => {
        const handleScroll = () => {
            setVisible(window.scrollY > 100);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <>
            <footer id="footer" className="footer">
                <div className="copyright">
                    &copy; Copyright{" "}
                    <strong>
                        <span>Magsayo Admin</span>
                    </strong>
                    . All Rights Reserved
                </div>

                <div className="credits">
                    Designed by{" "}
                    <a href="#" target="_blank" rel="noreferrer">
                        Magsayo Developers
                    </a>
                </div>
            </footer>

            {/* Back to Top Button */}
            {visible && (
                <button
                    onClick={topFunction}
                    style={{
                        position: "fixed",
                        right: "15px",
                        bottom: "15px",
                        zIndex: 9999,
                        borderRadius: "50%",
                        width: "40px",
                        height: "40px",
                        backgroundColor: "#0A192F",
                        color: "#fff",
                        border: "none",
                        cursor: "pointer"
                    }}
                >
                    <i className="bi bi-arrow-up-short"></i>
                </button>
            )}
        </>
    );
}

export default Footer;
